import {Component, inject} from '@angular/core';
import {CommonTableConfig} from '@lib-ui/common-table/models/common-table-config.class';
import {ProjectTableService} from './project-table.service';
import {CommonTableComponent} from '@lib-ui/common-table/ui/common-table.component';
import {ICommonTableAction, ICommonTableConfig} from '@lib-ui/common-table/models/common-table.interface';
import {RowAction} from '@lib-ui/common-table/models/common-table.enum';
import {MatDialog} from '@angular/material/dialog';
import {ProjectEditorComponent} from '../../components/project-editor/project-editor.component';
import {AdvancedSearchComponent} from '@lib-ui/advanced-search/ui/advanced-search.component';
import {FilterConfig} from '@lib-ui/advanced-search/models/advanced-search.interface';
import {MessageService} from '@lib-services/message.service';
import {filter, switchMap} from 'rxjs';
import {ProjectService} from '@lib-services/project.service';

@Component({
    selector: 'app-project',
    standalone: true,
    imports: [
        CommonTableComponent,
        AdvancedSearchComponent,
    ],
    templateUrl: './project.component.html',
    styleUrl: './project.component.scss'
})
export class ProjectComponent {
    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'id', title: 'ИН'},
            { name: 'name', title: 'Проект' },
            { name: 'companyName', title: 'Компания' },
        ],
        createButtonLabel: 'Добавить проект',
        showCreateButton: true,
        withCheckboxes: true,
        rowActions: [RowAction.DELETE],
    });
    filterConfig: FilterConfig[] = [
        // {
        //     type: 'common-dropdown',
        //     label: 'Компания',
        //     name: 'company.id',
        //     commonDropdownConfig: {
        //         service: inject(CompanySelectorService),
        //         formCtrl: new FormControl(),
        //     },
        // },
    ];

    protected projectTableService = inject(ProjectTableService);
    protected projectService = inject(ProjectService);
    protected dialog = inject(MatDialog);
    protected messageService = inject(MessageService);

    applyAction(value: ICommonTableAction): void {
        if (value.action === RowAction.CLICK) {
            this.openDialog({ projectId: Number(value.data[0]['id']) });
        }
        if (value.action === RowAction.CREATE) {
            this.openDialog({});
        }
        if (value.action === RowAction.DELETE) {
            const ids = value.data.map(el => Number(el['id']));
            this.deleteProjects(ids);
        }
    }

    openDialog(data: { projectId?: number }): void  {
        this.dialog.open(ProjectEditorComponent, {
            width: '50%',
            height: '30%',
            maxHeight: '250px',
            data: data,
            disableClose: true,
        }).afterClosed().subscribe({
            next: () => {
                this.projectTableService.updateData(this.tableConfig);
            }
        });
    };

    applyFilters(filterData: Record<string, string | null>): void {
        this.tableConfig.filters = filterData;
        this.tableConfig.paginatorConfig.pageIndex = 0;
        this.projectTableService.updateData(this.tableConfig);
    }

    deleteProjects(ids: number[]): void {
        this.messageService.confirmMessage({
            title: 'Удаление проекта(ов)',
            text: 'Вы действительно хотите удалить выбранные проекты?',
            primaryText: 'Удалить',
            secondaryText: 'Отмена',
            showSecondaryButton: true,
        }).pipe(
            filter(result => result),
            switchMap(() => {
                return this.projectService.deleteProjects(ids);
            }),
        ).subscribe({
            next: () => {
                this.messageService.successMessage('Проекты успешно удалены');
                this.projectTableService.updateData(this.tableConfig);
            },
            error: () => this.messageService.errorMessage('При удалении произошла ошибка')
        });
    }

}
